'use client';

export { GamesScreen } from './GamesScreen';
